import type { ProductLookupResult } from './barcodeLookup';
import { normalizeProductCode } from './catalogValidation';

/** Miss soft cuando falla el lookup remoto (no propagar throw a la UI). */
export function remoteLookupSoftMiss(barcode: string): Extract<ProductLookupResult, { kind: 'not_found' }> {
  return { kind: 'not_found', source: null, barcode };
}

/**
 * Valor del campo de búsqueda tras un scan/lookup.
 * Criterio: siempre el código escaneado normalizado — nunca el SKU.
 */
export function barcodeSearchFieldValue(
  result: { barcode: string },
  rawFallback = '',
): string {
  return result.barcode || normalizeProductCode(rawFallback) || rawFallback.trim();
}
